
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmallInfo from './ButtonSmallInfo.js'
export default class RoundSummary extends PIXI.Container {
    constructor(...arg) {
        super(...arg);

        this.round = 1;
        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));


        // //background
        // var popupBackground = new PIXI.Graphics();
        // popupBackground.beginFill(0x000000);
        // //popupBackground.drawRect(-500,-500, 1000, 1000);
        // popupBackground.alpha = 0.1;
        // this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);

        var styleTitle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        let styleMedium = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 16 * 2,
            fill: '#FFFFFF'
        });

        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });



        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 500, 500);
        graphics.drawRoundedRect(0, 0, 200, 500, 10);
        graphics.alpha = 0.8;
        this.container.addChild(graphics);


        //point background
        var pointCircle = new PIXI.Graphics();
        pointCircle.beginFill(0x479ACE); // or 0x479ACE or 0xC03500
        pointCircle.lineStyle(0, 0xFFFFFF, 1);
        pointCircle.drawRoundedRect(120 - 20, 85, 40, 235, 10);
        this.container.addChild(pointCircle);


        //player's score column indicator 
        this.playerScoreHighlight1 = new PIXI.Graphics();
        this.playerScoreHighlight1.lineStyle(2, 0xFFFF00, 1);
        this.playerScoreHighlight1.drawRoundedRect(120 - 20, 85, 40, 235, 10);
        this.container.addChild(this.playerScoreHighlight1);


        //point background 2
        var pointCircle = new PIXI.Graphics();
        pointCircle.beginFill(0xC03500); // or 0x479ACE or 0xC03500
        pointCircle.lineStyle(0, 0xFFFFFF, 1);
        pointCircle.drawRoundedRect(170 - 20, 85, 40, 235, 10);
        this.container.addChild(pointCircle);


        //player's score column indicator 
        this.playerScoreHighlight2 = new PIXI.Graphics();
        this.playerScoreHighlight2.lineStyle(2, 0xFFFF00, 1);
        this.playerScoreHighlight2.drawRoundedRect(170 - 20, 85, 40, 235, 10);
        this.container.addChild(this.playerScoreHighlight2);


        //textTitle
        this.textTitle = new PIXI.Text('Round', styleTitle);
        this.textTitle.x = 100;
        this.textTitle.y = 10;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //textHeader1
        this.textHeader1 = new PIXI.Text('', styleSmall);
        this.textHeader1.x = 10;
        this.textHeader1.y = 55;
        //this.textHeader1.anchor.set(0.5, 0);
        this.textHeader1.scale.set(0.5);
        this.container.addChild(this.textHeader1);

        //textHeader2
        this.textHeader2 = new PIXI.Text('You', styleSmall);
        this.textHeader2.x = 100;
        this.textHeader2.y = 55;
        //this.textHeader2.anchor.set(0.5, 0);
        this.textHeader2.scale.set(0.5);
        this.container.addChild(this.textHeader2);

        //textHeader3
        this.textHeader3 = new PIXI.Text('Computer', styleSmall);
        this.textHeader3.x = 150;
        this.textHeader3.y = 55;
        //this.textHeader3.anchor.set(0.5, 0);
        this.textHeader3.scale.set(0.5);
        this.container.addChild(this.textHeader3);

        //textRow1Col1
        this.textRow1Col1 = new PIXI.Text('Starter', styleNormal);
        this.textRow1Col1.x = 10;
        this.textRow1Col1.y = 90;
        this.textRow1Col1.scale.set(0.5);
        this.container.addChild(this.textRow1Col1);

        //textRow1Col1
        this.textRow1Col2 = new PIXI.Text('5', styleNormal);
        this.textRow1Col2.x = 120;
        this.textRow1Col2.y = 90;
        this.textRow1Col2.anchor.set(0.5, 0);
        this.textRow1Col2.scale.set(0.5);
        this.container.addChild(this.textRow1Col2);

        //textRow1Col3
        this.textRow1Col3 = new PIXI.Text('16', styleNormal);
        this.textRow1Col3.x = 170;
        this.textRow1Col3.y = 90;
        this.textRow1Col3.anchor.set(0.5, 0);
        this.textRow1Col3.scale.set(0.5);
        this.container.addChild(this.textRow1Col3);

        //textRow1Col1
        this.textRow2Col1 = new PIXI.Text('Play', styleNormal);
        this.textRow2Col1.x = 10;
        this.textRow2Col1.y = 135;
        this.textRow2Col1.scale.set(0.5);
        this.container.addChild(this.textRow2Col1);

        //textRow1Col1
        this.textRow2Col2 = new PIXI.Text('5', styleNormal);
        this.textRow2Col2.x = 120;
        this.textRow2Col2.y = 135;
        this.textRow2Col2.anchor.set(0.5, 0);
        this.textRow2Col2.scale.set(0.5);
        this.container.addChild(this.textRow2Col2);

        //textRow1Col3
        this.textRow2Col3 = new PIXI.Text('16', styleNormal);
        this.textRow2Col3.x = 170;
        this.textRow2Col3.y = 135;
        this.textRow2Col3.anchor.set(0.5, 0);
        this.textRow2Col3.scale.set(0.5);
        this.container.addChild(this.textRow2Col3);

        //textRow2Col1
        this.textRow3Col1 = new PIXI.Text('Hand', styleNormal);
        this.textRow3Col1.x = 10;
        this.textRow3Col1.y = 180;
        this.textRow3Col1.scale.set(0.5);
        this.container.addChild(this.textRow3Col1);

        //textRow2Col1
        this.textRow3Col2 = new PIXI.Text('23', styleNormal);
        this.textRow3Col2.x = 120;
        this.textRow3Col2.y = 180;
        this.textRow3Col2.anchor.set(0.5, 0);
        this.textRow3Col2.scale.set(0.5);
        this.container.addChild(this.textRow3Col2);

        //textRow2Col3
        this.textRow3Col3 = new PIXI.Text('4', styleNormal);
        this.textRow3Col3.x = 170;
        this.textRow3Col3.y = 180;
        this.textRow3Col3.anchor.set(0.5, 0);
        this.textRow3Col3.scale.set(0.5);
        this.container.addChild(this.textRow3Col3);

        //textRow2Col1
        this.textRow4Col1 = new PIXI.Text('Crib', styleNormal);
        this.textRow4Col1.x = 10;
        this.textRow4Col1.y = 225;
        this.textRow4Col1.scale.set(0.5);
        this.container.addChild(this.textRow4Col1);

        //textRow2Col1
        this.textRow4Col2 = new PIXI.Text('23', styleNormal);
        this.textRow4Col2.x = 120;
        this.textRow4Col2.y = 225;
        this.textRow4Col2.anchor.set(0.5, 0);
        this.textRow4Col2.scale.set(0.5);
        this.container.addChild(this.textRow4Col2);

        //textRow2Col3
        this.textRow4Col3 = new PIXI.Text('4', styleNormal);
        this.textRow4Col3.x = 170;
        this.textRow4Col3.y = 225;
        this.textRow4Col3.anchor.set(0.5, 0);
        this.textRow4Col3.scale.set(0.5);
        this.container.addChild(this.textRow4Col3);


        //line background
        var line = new PIXI.Graphics();
        line.lineStyle(2, 0xFFFFFF, 2);
        line.moveTo(10, 270);
        line.lineTo(190, 270);
        this.container.addChild(line);

        //textRow1Col1
        this.textRow5Col1 = new PIXI.Text('Total', styleNormal);
        this.textRow5Col1.x = 10;
        this.textRow5Col1.y = 280;
        this.textRow5Col1.scale.set(0.5);
        this.container.addChild(this.textRow5Col1);

        //textRow1Col1
        this.textRow5Col2 = new PIXI.Text('5', styleNormal);
        this.textRow5Col2.x = 120;
        this.textRow5Col2.y = 280;
        this.textRow5Col2.anchor.set(0.5, 0);
        this.textRow5Col2.scale.set(0.5);
        this.container.addChild(this.textRow5Col2);

        //textRow1Col3
        this.textRow5Col3 = new PIXI.Text('16', styleNormal);
        this.textRow5Col3.x = 170;
        this.textRow5Col3.y = 280;
        this.textRow5Col3.anchor.set(0.5, 0);
        this.textRow5Col3.scale.set(0.5);
        this.container.addChild(this.textRow5Col3);


        //textHeader1
        this.textAnalyzeHeader = new PIXI.Text('Discard Score', styleSmall);
        this.textAnalyzeHeader.x = 10;
        this.textAnalyzeHeader.y = 340;
        this.textAnalyzeHeader.scale.set(0.5);
        this.container.addChild(this.textAnalyzeHeader);

        //Analyze Round button
        this.btnAnalyze1 = new ButtonSmallInfo("100", 0x444444, 40, styleMedium);
        this.btnAnalyze1.x = 100;
        this.btnAnalyze1.y = 325;
        this.btnAnalyze1.interactive = true;
        this.btnAnalyze1.on('pointerdown', this.btnAnalyze1_onClick.bind(this));
        this.container.addChild(this.btnAnalyze1);

        //Analyze Round  button
        this.btnAnalyze2 = new ButtonSmallInfo("100", 0x444444, 40, styleMedium);
        this.btnAnalyze2.x = 150;
        this.btnAnalyze2.y = 325;
        this.btnAnalyze2.interactive = true;
        this.btnAnalyze2.on('pointerdown', this.btnAnalyze2_onClick.bind(this));
        this.container.addChild(this.btnAnalyze2);

        //Explain  button
        this.btnExplain = new Button("Explain", 0xC03500, 190);
        this.btnExplain.x = 5;
        this.btnExplain.y = 370;
        this.btnExplain.interactive = true;
        this.btnExplain.on('pointerdown', this.btnExplain_onClick.bind(this));
        this.container.addChild(this.btnExplain);

        //Next Round  button
        this.btnNext = new Button("Play", 0x479ACE, 190);
        this.btnNext.x = 5;
        this.btnNext.y = 435;
        this.btnNext.interactive = true;
        this.btnNext.on('pointerdown', this.btnNext_onClick.bind(this));
        this.container.addChild(this.btnNext);

        //rematch indicator ready
        this.btnHighlightReady = new PIXI.Graphics();
        this.btnHighlightReady.lineStyle(2, 0xFFFF00, 3);
        this.btnHighlightReady.drawRoundedRect(5, 435, 190, 60, 10);
        this.container.addChild(this.btnHighlightReady);






    }
    update() {
        let isDirty = false;
        let hideContinue = this.hideContinue;
        let readyPlayer1 = this.readyPlayer1;
        let readyPlayer2 = this.readyPlayer2;


        if (this.btnHighlightReady.visible !== readyPlayer1 || readyPlayer2) isDirty = true;

        this.btnHighlightReady.visible = readyPlayer1 || readyPlayer2;

        //if hideContinue hide btnHighlightReady
        if (hideContinue) this.btnHighlightReady.visible = false;

        this.isDirty = isDirty;
    }
    updateLayout() {
        let scoreSummary = this.scoreSummary;
        let tablePosition = this.tablePosition || null;
        let hideContinue = this.hideContinue;

        this.round = scoreSummary.round;
        if (!scoreSummary.hasOwnProperty('player1')) scoreSummary["player1"] = {};
        if (!scoreSummary.hasOwnProperty('player2')) scoreSummary["player1"] = {};

        this.textHeader2.text = scoreSummary["player1"].name || "You";
        this.textRow1Col2.text = (scoreSummary["player1"].starter || 0);
        this.textRow2Col2.text = (scoreSummary["player1"].play || 0);
        this.textRow3Col2.text = scoreSummary["player1"].hand || 0;
        this.textRow4Col2.text = scoreSummary["player1"].crib || 0;
        this.textRow5Col2.text = scoreSummary["player1"].total || 0;

        this.textHeader3.text = scoreSummary["player2"].name || "Computer";
        this.textRow1Col3.text = (scoreSummary["player2"].starter || 0);
        this.textRow2Col3.text = (scoreSummary["player2"].play || 0);
        this.textRow3Col3.text = scoreSummary["player2"].hand || 0;
        this.textRow4Col3.text = scoreSummary["player2"].crib || 0;
        this.textRow5Col3.text = scoreSummary["player2"].total || 0;


        this.btnAnalyze1.text = scoreSummary["player1"].analyzerScore || 0;
        this.btnAnalyze2.text = scoreSummary["player2"].analyzerScore || 0;

        //show score column indicator
        this.playerScoreHighlight1.visible = tablePosition == "player1";
        this.playerScoreHighlight2.visible = tablePosition == "player2";


        //if hideContinue hide btnNext
        this.btnNext.alpha = hideContinue ? 0.5 : 1;
        //if hideContinue hide btnHighlightReady
        if (hideContinue) this.btnHighlightReady.visible = false;
    }
    btnExplain_onClick(event) {
        if (this.onExplain) {
            this.onExplain(this.round);
        }
        event.stopPropagation();
    }
    btnNext_onClick(event) {
        if (this.onNext) {
            this.onNext();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);

    }
    btnAnalyze1_onClick(event) {
        if (this.onAnalyze) {
            this.onAnalyze(this.round, "player1");
        }
        event.stopPropagation();
    }
    btnAnalyze2_onClick(event) {
        if (this.onAnalyze) {
            this.onAnalyze(this.round, "player2");
        }
        event.stopPropagation();
    }
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        //  this.parent.isDirty = true;
        //   this.parent.removeChild(this);
    }
}